import { useNavigate } from 'react-router-dom';
import { ISelectOption } from '@constants/entities/ui';
import { useProject } from '@context/Project';
import { useToast } from '@context/Toast';
import useProjectData from '@hooks/useProjectData';
import useProjectId from '@hooks/useProjectId';
import { ROUTES } from '@router/routes';
import { useCopyModelToProjectMutation } from '@store/services/projects';
import { parseErrorResponse } from '@utils/helpers';

const useCopyModel = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const projectId = useProjectId();
  const [{ name }] = useProjectData();
  const {
    toolbox: { mode },
  } = useProject();

  const [copyModel] = useCopyModelToProjectMutation();

  const handleCopyModel = async (
    targetProject: ISelectOption | null,
    onFinish: () => void,
  ) => {
    try {
      if (!mode) throw new Error('Mode is not defined');

      await copyModel({
        sourceProjectId: projectId,
        targetProjectId: targetProject?.value.toString() ?? '',
        mode,
      }).unwrap();

      showToast(
        `“${name}” model was successfully copied to ${targetProject?.label}.`,
        'success',
        {
          action: {
            label: 'Open model',
            onClick: () => {
              navigate(
                `${ROUTES.PROJECT.MODEL.replace(
                  ':id',
                  targetProject?.value.toString() ?? '',
                )}?mode=${mode}`,
              );
            },
          },
        },
      );
    } catch (error) {
      showToast(parseErrorResponse(error), 'error');
    } finally {
      onFinish();
    }
  };

  return { handleCopyModel };
};

export default useCopyModel;
